import { Navigate, useLocation } from "react-router-dom";

export default function SignIn() {
  const location = useLocation();

  return (
    <Navigate
      replace
      to={{
        pathname: "/auth",
        search: location.search,
        hash: location.hash,
      }}
    />
  );
}
